import { Chip } from '@mui/material';
import styled from '@emotion/styled';

export const ChipStyled = styled(Chip)`
  & .MuiChip-label {
    white-space: nowrap;
    padding: 0 10px;
  }
`;
